import type { CompanionColour } from '../lib/youthRewards'

export type NixiOutfit = 'none' | 'pjs' | 'tshirt' | 'schoolbag'
export type NixiProp = 'none' | 'toothbrush' | 'book' | 'bed' | 'hat' | 'schoolbag' | 'teddy'
export type NixiMood = 'idle' | 'happy' | 'excited' | 'chewing' | 'sleepy'

const companionSources: Record<CompanionColour, string> = {
  pink: '/nixi-girl-approved-pink.webp',
  blue: '/nixi-girl-approved-pink.webp',
  green: '/nixi-girl-approved-green.webp',
}

interface AnimatedCompanionProps {
  colour: CompanionColour
  size?: 'small' | 'large'
  eating?: boolean
  happy?: boolean
  outfit?: NixiOutfit
  prop?: NixiProp
  mood?: NixiMood
  className?: string
}

export function AnimatedCompanion({
  colour,
  size = 'large',
  eating = false,
  happy = false,
  outfit = 'none',
  prop = 'none',
  mood = 'idle',
  className = '',
}: AnimatedCompanionProps) {
  const dimension = size === 'small' ? 118 : 220
  const animatedMood: NixiMood = eating ? 'chewing' : happy && mood === 'idle' ? 'happy' : mood
  const motionClass = animatedMood === 'excited'
    ? 'marnixia-nixi-bounce'
    : animatedMood === 'happy'
      ? 'marnixia-nixi-wave'
      : animatedMood === 'sleepy'
        ? 'marnixia-nixi-sleep'
        : 'marnixia-nixi-float'

  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: dimension, height: dimension }}
      aria-label={`${colour} Nixi, the Marnixia companion`}
      role="img"
      data-outfit={outfit}
      data-prop={prop}
      data-mood={animatedMood}
    >
      <style>{`
        @keyframes marnixia-nixi-float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-5px); } }
        @keyframes marnixia-nixi-wave { 0%,100% { transform: rotate(0) translateY(0); } 35% { transform: rotate(-2deg) translateY(-4px); } 70% { transform: rotate(2deg) translateY(-2px); } }
        @keyframes marnixia-nixi-bounce { 0%,100% { transform: translateY(0) scale(1); } 45% { transform: translateY(-10px) scale(1.03); } }
        @keyframes marnixia-nixi-sleep { 0%,100% { transform: translateY(1px) scale(.99); } 50% { transform: translateY(4px) scale(1); } }
        .marnixia-nixi-float { animation: marnixia-nixi-float 4.8s ease-in-out infinite; }
        .marnixia-nixi-wave { animation: marnixia-nixi-wave 1.1s ease-in-out 2; }
        .marnixia-nixi-bounce { animation: marnixia-nixi-bounce .8s ease-in-out 2; }
        .marnixia-nixi-sleep { animation: marnixia-nixi-sleep 3s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .marnixia-nixi-float, .marnixia-nixi-wave, .marnixia-nixi-bounce, .marnixia-nixi-sleep { animation: none !important; }
        }
      `}</style>
      <img
        src={companionSources[colour]}
        alt=""
        aria-hidden="true"
        className={`h-full w-full object-contain drop-shadow-xl ${motionClass}`}
        draggable={false}
      />
    </div>
  )
}

